import {
  mdiCog,
  mdiCalendarClock,
  mdiCurrencyUsd,
  mdiCashRegister,
  mdiViewDashboard,
  mdiBrightnessPercent,
  mdiEmoticonOutline,
  mdiBookOpenPageVariantOutline,
  mdiAccountGroupOutline,
  mdiChartLine,
  mdiBullhornOutline,
  mdiPackageVariant,
  mdiCashRegisterOutline,
  mdiFaceWomanShimmer,
  mdiTruckDeliveryOutline,
} from '@mdi/js'

export default [
  {
    title: 'Dashboard',
    icon: mdiViewDashboard,
    to: 'dashboard',
    action: 'read',
    resource: 'Public',
  },
  
  {
    title: 'Estética',
    icon: mdiFaceWomanShimmer,
    to: '',
    children: [
      {
        title: 'Avaliação Corporal',
        to: 'aesthetics',
        action: 'read',
        resource: 'Public',
      },
    ],
  },
  {
    title: 'Delivery',
    icon: mdiTruckDeliveryOutline,
    to: '',
    children: [
      {
        title: 'Central de Delivery',
        to: 'delivery_center',
        action: 'read',
        resource: 'Sales',
      },
      {
        title: 'Historico de Delivery',
        to: 'delivery_history',
        action: 'read',
        resource: 'Sales',
      },
      {
        title: 'Pizzas',
        to: 'pizza_catalog',
        action: 'read',
        resource: 'Sales',
      },
      {
        title: 'Configurações',
        to: 'system/configuration/delivery',
        action: 'read',
        resource: 'Sales',
      },
    ],
  },
  
  {
    title: 'Agendamento',
    icon: mdiCalendarClock,
    to: 'calendar',
    action: 'read',
    resource: 'Calendar',
  },
  {
    title: 'Vendas',
    icon: mdiBrightnessPercent,
    children: [
      {
        title: 'Vendas Diárias',
        to: 'daily_sales',
        action: 'read',
        resource: 'Sales',
      },
      {
        title: 'Vendas Realizadas',
        to: 'sales',
        action: 'read',
        resource: 'SalesView',
      },
      {
        title: 'Pagamentos',
        to: 'payments_sales',
        action: 'read',
        resource: 'SalesView',
      },
      {
        title: 'Ponto de Venda',
        to: 'ponto_de_venda',
        action: 'read',
        resource: 'Sales',
      },
      {
        title: 'Auto Atendimento',
        to: 'auto_atendimento',
        action: 'read',
        resource: 'Sales',
      },
     
    ],
  },
  {
    title: 'Clientes',
    icon: mdiEmoticonOutline,
    to: 'customer',
    action: 'read',
    resource: 'Customer',
  },
  {
    title: 'Catalogo',
    icon: mdiBookOpenPageVariantOutline,
    to: '',
    children: [
      {
        title: 'Serviços',
        to: 'service',
        action: 'read',
        resource: 'Service',
      },
      {
        title: 'Produtos',
        to: 'product',
        action: 'read',
        resource: 'Product',
      },
      {
        title: 'Fornecedores',
        to: 'supplier',
        action: 'read',
        resource: 'Supplier',
      },
      
      // {
      //   title: 'Estoque',
      //   to: 'stock/stock',
      // },
    ],
  },
  {
    title: 'Estoque',
    icon: mdiPackageVariant,
    to: '',
    children: [
      {
        title: 'Estoque',
        to: 'stock/stock',
        action: 'read',
        resource: 'Stock',
      },
      {
        title: 'Pedidos de Compra',
        to: 'stock/purchase_orders',
        action: 'read',
        resource: 'StockPurchase',
      },
      {
        title: 'Entradas de Estoque',
        to: 'stock/purchase_entries',
        action: 'read',
        resource: 'StockPurchase',
      },
    ],
  },
  {
    title: 'Equipe',
    icon: mdiAccountGroupOutline,
    to: '',
    children: [
      {
        title: 'Colaboradores',
        to: 'employee',
        action: 'read',
        resource: 'Employee',
      },
      {
        title: 'Turnos Programados',
        to: 'turno_programado',
        action: 'read',
        resource: 'ScheduledShift',
      },
      {
        title: 'Controle de Ponto',
        to: 'controle_ponto',
        action: 'read',
        resource: 'PointControl',
      },
      {
        title: 'Ciclos de Pagamento',
        to: 'pay_professional',
        action: 'read',
        resource: 'TeamPayment',
      },
    ],
  },
  {
    title: 'Caixa',
    icon: mdiCashRegister,
    children: [
      {
        title: 'Caixa',
        to: 'cash_open',
        action: 'read',
        resource: 'Cash',
      },
      {
        title: 'Cartões',
        to: 'card',
        action: 'read',
        resource: 'Card',
      },

      // {
      //   title: 'Fluxo de Caixa',
      //   to: { name: 'financial/cash_flow' },
      // },
    ],
  },

  // {
  //   title: 'Estoque',
  //   icon: mdiCubeScan,
  //   children: [
  //     {
  //       title: 'Gerenciar Estoque',
  //       to: 'stock/stock',
  //     },
  //     {
  //       title: 'Lançar Compra',
  //       to: {name:'stock/purchase_stock', params:{action:'purchase'}}
  //     },
  //     {
  //       title: 'Lançar Movimentação',
  //       to:{name: 'stock/movement_stock',params:{action:'movement'}}

  //     },

  //   ],
  // },
  {
    title: 'Financeiro',
    icon: mdiCurrencyUsd,
    children: [
      {
        title: 'Despesas',
        to: { name: 'financial/expense' },
        action: 'read',
        resource: 'FinancialExpense',
      },
      {
        title: 'Receitas',
        to: { name: 'financial/revenue', params: { paid_bills: 'nao' } },
        action: 'read',
        resource: 'FinancialRevenue',
      },
      {
        title: 'Fluxo de Caixa',
        to: { name: 'financial/cash_flow' },
        action: 'read',
        resource: 'FinancialCashFlow',
      },
      {
        title: 'Notas Fiscais',
        to: { name: 'financial/invoice' },
        action: 'read',
        resource: 'FinancialInvoice',
      },
    ],
  },
  {
    title: 'Marketing',
    icon: mdiBullhornOutline,
    children: [
      {
        title: 'Ofertas',
        to: { name: 'marketing/offers' },
        action: 'read',
        resource: 'Marketing',
      },
    ],
  },
  {
    title: 'Relatório',
    icon: mdiChartLine,
    to: 'system/report',
    action: 'read',
    resource: 'Reports',
  },
  {
    title: 'Configurações',
    icon: mdiCog,
    children: [
      // {
      //   title: 'Gorjetas',
      //   to: 'system/config_gratuity',
      //   action: 'read',
      //   resource: 'Configuration',
      // },
      {
        title: 'Configurações',
        to: 'system/configuration',
        action: 'read',
        resource: 'Configuration',
      },

      // {
      //   title: 'Preferências',
      //   to: 'system/preferences',
      // },
      {
        title: 'Controle de Acesso',
        to: 'system/access_control',
        action: 'read',
        resource: 'AccessControl',
      },
    ],
  },
]
